/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Fab, IconButton, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { deletedRequirement } from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from "sweetalert2";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { AddActivity } from "./add_activity/AddActivity";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { ActiveActivityDto, RequirementDto } from "./add_activity/AddActivity";
import moment from "moment";
import { getTranslationsForTable } from "src/shared/traslations";
import WarningIcon from '@mui/icons-material/Warning';
import { tableStyles } from "src/shared/util/tableStyles";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export const OptimizationActivities = () => {
    const dispatch = useDispatch();
    const { optimizationRequirements, locationId, locationName } = useSelector((state) => state.location);

    const rows: GridRowsProp = optimizationRequirements.map((item: any) => {
        return {
            optimizationActivityId: item.optimizationActivityId,
            variableId: item.variableId,
            originFieldActivityExecutedDate: moment(
                item.originFieldActivityExecutedDate
            ).format("DD-MM-YYYY"),
            requiredDate: moment(item.requiredDate).format("DD-MM-YYYY"),
            simulationDate: moment(item.simulationDate).format("DD-MM-YYYY"),
            executedDate: item.executedDate !== null ? moment(item.executedDate).format("DD-MM-YYYY") : '',
            activity: item.activity,
            requiredBy: item.requiredBy,
            lastProduction: item.lastProduction,
            targetProduction: item.targetProduction,
            status: item.status,
            comments: item.comments,
            isWellWithMultiplesTDSEntries: item.isWellWithMultiplesTDSEntries,
        };
    })

    const columns: GridColDef[] = [
        {
            field: "originFieldActivityExecutedDate",
            headerName: "Fecha Estudio",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "requiredDate",
            headerName: "Fecha Solicitado ",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "simulationDate",
            headerName: "Fecha Simulación",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "executedDate",
            headerName: "Fecha Ejecutado",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "activity",
            headerName: "Tipo de Actividad",
            minWidth: 150,
            flex: 1,
        },
        {
            field: "requiredBy",
            headerName: "Solicitado por",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "isWellWithMultiplesTDSEntries", headerName: "Repetitivo", minWidth: 50, flex: 0.5, renderCell: (params) => {
                return params.row.isWellWithMultiplesTDSEntries ?
                    <Grid sx={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center", gap: 1 }}>
                        <WarningIcon color="warning" fontSize="small" />
                        <Typography color="warning">
                            Si
                        </Typography>
                    </Grid>
                    :
                    <Grid sx={{ display: "flex", height: "100%", alignItems: "center", justifyContent: "center", gap: 1 }}>
                        <Typography color="text.secondary">
                            No
                        </Typography>
                    </Grid>;
            }
        },
        {
            field: "lastProduction",
            headerName: "Ultima medida Aceptada",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "targetProduction",
            headerName: "Ganancial Estimado",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "status",
            headerName: "Estado",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "comments",
            headerName: "Comentarios",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "actions",
            headerName: "",
            filterable: false,
            align: "center",
            headerAlign: "center",
            flex: 1,
            renderHeader: () => (
                <IconButton onClick={() => console.log("Header action")}>
                    <MoreVertIcon />
                </IconButton>
            ),
            renderCell: (params) => {
                return (
                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            mt:1
                        }}
                    >
                        <IconButton
                            size="small"
                            color="error"
                            onClick={() =>
                                handleDeleteRequirement(
                                    params.row.optimizationActivityId,
                                    params.row.variableId
                                )
                            }
                        >
                            <DeleteForeverIcon fontSize="medium" />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() =>
                                handleEditRow(params.row.optimizationActivityId)
                            }
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const [showAddRequirements, setShowAddRequirements] = useState(false);

    const [activeActivity, setActiveActivity] = useState<ActiveActivityDto | undefined>(undefined)

    const handleDeleteRequirement = (
        optimizationActivityId: string,
        variableId: string
    ) => {
        Swal.fire({
            title: "Estas seguro?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SI, eliminar!",
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    optimizationActivityId,
                    variableId,
                };

                dispatch(deletedRequirement(data, locationId));

                Swal.fire({
                    title: "Eliminado!",
                    icon: "success",
                });
            }
        });
    };

    const handleShowAddActivity = () => {
        setShowAddRequirements(!showAddRequirements);
    };

    const paginationModel = { page: 0, pageSize: 10 };

    const handleEditRow = (optimizationActivityid: string) => {


        const requirementsActivities = optimizationRequirements.filter(x => x.optimizationActivityId === optimizationActivityid)

        if (requirementsActivities.length === 0) return;

        const ActiveRequirements: RequirementDto[] = []

        requirementsActivities.forEach((item) => {
            const { variableId, activity, status, blocker, comments, simulationDate, lastProduction, targetProduction, isWellWithMultiplesTDSEntries } = item;
            const requirement: RequirementDto = {
                id: variableId,
                location: locationName,
                name: activity,
                value: 'Si',
                type: 'Optimization',
                comments,
                blocker,
                status: status,
                simulationDate,
                lastProduction,
                targetProduction,
                isWellWithMultiplesTDSEntries,
            };
            ActiveRequirements.push(requirement);
        });

        const activeActivity: ActiveActivityDto = {
            optimizationActivityId: requirementsActivities[0].optimizationActivityId,
            requirements: ActiveRequirements,
            requiredUserId: requirementsActivities[0].requiredById,
            requiredDate: requirementsActivities[0].requiredDate,
            originFieldActivityId: requirementsActivities[0].originFieldActivityId,
        }

        setActiveActivity(activeActivity);
        setShowAddRequirements(true);
    }


    return (
        <>
            {showAddRequirements && (
                <AddActivity
                    show={showAddRequirements}
                    setShowPendingActivities={setShowAddRequirements}
                    activeActivity={activeActivity}
                    setActiveActivity={setActiveActivity}
                    TabDisable={true}
                />
            )}
            <Grid>
                <Grid size={12}>
                    <DataGrid
                        rows={getTranslationsForTable([...rows], "es", [
                            "status",
                        ])}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[10, 20, 50, 100]}
                        checkboxSelection={false}
                        sx={{
                            mt: 2,
                            height: {
                                md: `calc(100vh - 465px)`,
                                lg: `calc(100vh - 465px)`,
                                xl: `calc(100vh - 465px)`,
                            },
                            ...tableStyles,
                        }}
                        getRowId={(row) =>
                            row.optimizationActivityId + row.variableId
                        }
                    />
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mt: 2,
                    }}
                >
                    <Fab
                        size="medium"
                        color="primary"
                        aria-label="add"
                        onClick={handleShowAddActivity}
                    >
                        <AddIcon />
                    </Fab>
                </Grid>
            </Grid>
        </>
    );
};
